import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const LogoLightbox = ({ p, open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl bg-white p-6 sm:p-10" data-testid={`logo-lightbox-${p.slug}`}>
      <DialogTitle className="font-display text-lg">{p.title}</DialogTitle>
      <div className="flex items-center justify-center min-h-[300px]">
        <img src={p.image} alt={p.title} className="max-w-full max-h-[65vh] object-contain" />
      </div>
      <Link to={`/layihe/${p.slug}`} className="link-arrow self-start" data-testid={`logo-lightbox-link-${p.slug}`}>
        Ətraflı <ArrowRight size={15} className="arr" />
      </Link>
    </DialogContent>
  </Dialog>
);

const LogoOpener = ({ p, className, children, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`${className} text-left w-full cursor-zoom-in`} aria-label={p.title} data-testid={testid}>{children}</button>
      <LogoLightbox p={p} open={open} onOpenChange={setOpen} />
    </>
  );
};

const Opener = ({ p, className, children, testid }) =>
  p.category === "logo"
    ? <LogoOpener p={p} className={className} testid={testid}>{children}</LogoOpener>
    : <Link to={`/layihe/${p.slug}`} className={className} aria-label={p.title} data-testid={testid}>{children}</Link>;

export const ConceptBadge = () => (
  <span className="absolute top-3 right-3 text-[10px] uppercase tracking-[0.18em] bg-[#111110]/80 text-[#D6AD62] px-2.5 py-1 rounded-full backdrop-blur" title="Nümunə / konsept layihə">
    Konsept
  </span>
);

const imgCls = (p) => (p.category === "logo" ? "w-full h-full object-contain p-6 bg-white" : "w-full h-full object-cover");

export const ProjectCard = ({ p }) => (
  <article data-testid={`project-card-${p.slug}`} className="group">
    <Opener p={p} className="block relative rounded-xl overflow-hidden aspect-[16/10] bg-[#EEE7DC] img-zoom">
      <img src={p.image} alt={p.title} loading="lazy" className={imgCls(p)} />
      <span className="absolute top-3 left-3 text-[11px] bg-white/90 px-3 py-1 rounded-full">{p.category_label}</span>
      {p.is_concept && <ConceptBadge />}
    </Opener>
    <h3 className="font-display text-lg font-semibold mt-5">{p.title}</h3>
    <p className="text-sm text-[#77736B] mt-2 max-w-[300px] leading-relaxed">{p.short_description}</p>
    <Link to={`/layihe/${p.slug}`} className="link-arrow mt-5" data-testid={`project-link-${p.slug}`}>
      İşə baxın <ArrowRight size={15} className="arr" />
    </Link>
  </article>
);

export const ProjectThumb = ({ p }) => (
  <Opener p={p} testid={`project-thumb-${p.slug}`} className="group block">
    <div className="relative rounded-lg overflow-hidden aspect-[16/10] bg-[#EEE7DC] img-zoom">
      <img src={p.image} alt={p.title} loading="lazy" className={imgCls(p)} />
      {p.is_concept && <ConceptBadge />}
    </div>
    <p className="font-display font-semibold text-sm mt-3 group-hover:underline underline-offset-4">{p.title}</p>
    <p className="text-xs text-[#77736B] mt-1">{p.category_label}</p>
  </Opener>
);
